/**
 * Identity minting (T-04, T-1g-QUEUE). `capture_id` identifies the capture
 * group (domain identity); `client_id` is the transport idempotency key
 * (design §1.4) — minted exactly once when the group is created (DRAFT) and
 * reused verbatim on every retry, including after a restart. The PWA never
 * mints a second `client_id` for the same group, and never re-mints one
 * after a crash: the minted id is persisted as part of the DRAFT/HELD write
 * itself (see state-machine.ts `saveToProject`), so recovery reuses it
 * rather than generating a new one.
 */

export function mintCaptureId(): string {
  return crypto.randomUUID();
}

export function mintClientId(): string {
  return crypto.randomUUID();
}
